/** Limite de voix simultanées : au plus `maxVoices` sons en cours, `maxPerKey` par clé, et un intervalle minimal entre deux départs d'une même clé. */
export interface VoiceLimits { maxVoices: number; maxPerKey: number; minIntervalMs: number; }
export const DEFAULT_VOICE_LIMITS: VoiceLimits = { maxVoices: 12, maxPerKey: 3, minIntervalMs: 60 };

export class VoiceLimiter {
  private active: { key: string; until: number }[] = [];
  private lastStart = new Map<string, number>();
  constructor(private readonly limits: VoiceLimits = DEFAULT_VOICE_LIMITS) {}

  /** Demande une voix pour `key` à l'instant `nowMs` ; `true` si le son peut partir (il est alors compté jusqu'à `nowMs + durationMs`). */
  request(key: string, nowMs: number, durationMs: number): boolean {
    this.prune(nowMs);
    const last = this.lastStart.get(key);
    if (last !== undefined && nowMs - last < this.limits.minIntervalMs) return false;
    if (this.active.length >= this.limits.maxVoices) return false;
    let perKey = 0;
    for (const v of this.active) if (v.key === key) perKey++;
    if (perKey >= this.limits.maxPerKey) return false;
    this.active.push({ key, until: nowMs + Math.max(1, durationMs) });
    this.lastStart.set(key, nowMs);
    return true;
  }

  activeCount(nowMs: number): number { this.prune(nowMs); return this.active.length; }
  reset(): void { this.active = []; this.lastStart.clear(); }
  private prune(nowMs: number): void { this.active = this.active.filter((v) => v.until > nowMs); }
}

/** Variation de hauteur en cents, uniforme dans [-spread, +spread], pour que les sons répétés ne soient pas identiques. */
export function pitchDetune(random: () => number, spreadCents = 80): number {
  return Math.round((random() * 2 - 1) * spreadCents);
}
